import { useState, useEffect } from "react";
import { Department } from "@/hooks/queries/useDepartmentQueries";
import type { User } from "@/hooks/useAuth";

interface CompanyUser extends User {
  departments: Array<{ _id: string; name: string }>;
}

/**
 * Custom hook for managing company admin dashboard state
 */
export const useCompanyAdminDashboard = (user: User | null) => {
  const [selectedPeriod, setSelectedPeriod] = useState("month");
  const [newDepartmentName, setNewDepartmentName] = useState("");
  const [searchTerm, setSearchTerm] = useState("");
  const [shouldFetch, setShouldFetch] = useState(false);

  // Initialize local departments from user data
  const [localDepartments, setLocalDepartments] = useState<Department[]>(
    (user?.departments || []).map((dept: any) => ({
      _id: dept._id || dept.id,
      name: dept.name,
      companyId: dept.companyId || (user as CompanyUser)?._id || "",
      employees: dept.employees || [],
      coursesAssignedToDepartment: dept.coursesAssignedToDepartment || [],
      createdAt: dept.createdAt || new Date().toISOString(),
      isActive: dept.isActive !== undefined ? dept.isActive : true,
      departmentAdmin: dept.departmentAdmin,
    }))
  );

  // Set shouldFetch when user ID is available
  useEffect(() => {
    if (user?._id) {
      setShouldFetch(true);
    }
  }, [user?._id]);

  return {
    selectedPeriod,
    setSelectedPeriod,
    newDepartmentName,
    setNewDepartmentName,
    searchTerm,
    setSearchTerm,
    shouldFetch,
    localDepartments,
    setLocalDepartments,
  };
};
